import React, { useState, useEffect } from 'react';

const UrlFormInput = ({ onProcess }) => {

  const [url, setUrl] = useState('');
  const [getUrl, setGetUrl] = useState('');
  const [isError, setIsError] = useState(false);


  const handleInputChange = (event) => {
    setUrl(event.target.value);
    setIsError(false);
  };

  const handleButtonClick = () => {
    //urlを検証
    const urlPattern = /^https:\/\/([a-z]{2})\.finalfantasyxiv\.com\/lodestone\//;
    if (!url || !urlPattern.test(url)) {
      setIsError(true);
      return;
    }
    //url問題無ければ処理
    setIsError(false);
    setGetUrl(url);
  };


  useEffect(() => {
    if (getUrl) {

      // APIのエンドポイントを指定
      fetch(`/req_api/entry.php?url=${url}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {

          if (data.url === null) {
            console.log('エラー');
            setIsError(true);
            return;
          } else {
            //setUrl(data.url);
            onProcess(getUrl, data.url);
          }

        })
        .catch(error => {
          setIsError(error);
          console.error('Error fetching entry:', error);
        });

    }
  }, [getUrl, url, onProcess]);

  return (
    <section id="main">
      <div id="main_inner">
        <h2>ロドストURL短縮</h2>
        <p className="read">ロードストーンのURLを短縮できます。<br />短縮したい「<strong>https://jp.finalfantasyxiv.com/lodestone/****</strong>」の形のURLを入力してください。</p>
        {isError && <p className="error">URLの形式が不正です。</p>}
        <input type="text" name="url" value={url} onChange={handleInputChange} placeholder="例：https://jp.finalfantasyxiv.com/lodestone/character/aaaaa/blog/bbbbb/" className="text" />
        <input type="button" name="regist" value="短縮URLを生成" className="submit" onClick={handleButtonClick} />
      </div>
    </section>
  );
};

export default UrlFormInput;